// extracted by mini-css-extract-plugin
export var BtnV2 = "form-404-module--BtnV2--b02d7";
export var BtnV2Black = "form-404-module--BtnV2--black--e1029";
export var BtnV2Borderless = "form-404-module--BtnV2--borderless--9258a";
export var BtnV2Cloud = "form-404-module--BtnV2--cloud--94eeb";
export var BtnV2Disabled = "form-404-module--BtnV2--disabled--7ffc1";
export var BtnV2Focusable = "form-404-module--BtnV2--focusable--1543c";
export var BtnV2Fullwidth = "form-404-module--BtnV2--fullwidth--7b111";
export var BtnV2Gold = "form-404-module--BtnV2--gold--70d6e";
export var BtnV2Grey = "form-404-module--BtnV2--grey--c9793";
export var BtnV2Icon = "form-404-module--BtnV2--icon--8883e";
export var BtnV2Lg = "form-404-module--BtnV2--lg--d473b";
export var BtnV2Midnight = "form-404-module--BtnV2--midnight--c89ec";
export var BtnV2Multiline = "form-404-module--BtnV2--multiline--c7411";
export var BtnV2Nofocus = "form-404-module--BtnV2--nofocus--c31f1";
export var BtnV2Secondary = "form-404-module--BtnV2--secondary--6bcd0";
export var BtnV2Sm = "form-404-module--BtnV2--sm--3d74b";
export var BtnV2Solid = "form-404-module--BtnV2--solid--d400a";
export var BtnV2Square = "form-404-module--BtnV2--square--23f28";
export var BtnV2Success = "form-404-module--BtnV2--success--1cbf3";
export var BtnV2Text = "form-404-module--BtnV2--text--87332";
export var BtnV2Warning = "form-404-module--BtnV2--warning--b3381";
export var BtnV2White = "form-404-module--BtnV2--white--b7b4d";
export var BtnV2Xl = "form-404-module--BtnV2--xl--c86fb";
export var BtnV2Yellow = "form-404-module--BtnV2--yellow--ac424";
export var ColorBlock = "form-404-module--ColorBlock--63ab0";
export var ColorBlockColorGrey = "form-404-module--ColorBlock--colorGrey--38757";
export var ColorBlockGrey = "form-404-module--ColorBlock--grey--9823e";
export var ColorBlockMidGrey = "form-404-module--ColorBlock--midGrey--71168";
export var ColorBlockPink = "form-404-module--ColorBlock--pink--121dc";
export var ColorBlockPrimary = "form-404-module--ColorBlock--primary--207e7";
export var ColorBlockPrimaryDark = "form-404-module--ColorBlock--primaryDark--63988";
export var ColorBlockPrimaryLight = "form-404-module--ColorBlock--primaryLight--f62ba";
export var ColorBlockPrimaryMid = "form-404-module--ColorBlock--primaryMid--f7d39";
export var ColorBlockPurple = "form-404-module--ColorBlock--purple--f7121";
export var ColorBlockRed = "form-404-module--ColorBlock--red--42331";
export var ColorBlockSecondary = "form-404-module--ColorBlock--secondary--86c64";
export var ColorBlockSecondaryDark = "form-404-module--ColorBlock--secondaryDark--b128e";
export var ColorBlockSecondaryLight = "form-404-module--ColorBlock--secondaryLight--72af6";
export var ColorBlockSecondaryMid = "form-404-module--ColorBlock--secondaryMid--e5753";
export var ColorBlockText = "form-404-module--ColorBlock--text--42fb8";
export var ColorBlockYellow = "form-404-module--ColorBlock--yellow--96a4e";
export var ColorBlocks = "form-404-module--ColorBlocks--b4a7a";
export var DashboardTopoptions = "form-404-module--Dashboard--topoptions--3cd58";
export var HideEmbedded = "form-404-module--HideEmbedded--82be2";
export var ShowEmbedded = "form-404-module--ShowEmbedded--49312";
export var Template__descriptionContent = "form-404-module--Template__description-content--5502b";
export var __active = "form-404-module--__active--076b3";
export var __custom = "form-404-module--__custom--368d8";
export var _pin = "form-404-module--_pin--bd061";
export var _pinText = "form-404-module--_pinText--184df";
export var aliceCarousel__dots = "form-404-module--alice-carousel__dots--4adc7";
export var aliceCarousel__dotsItem = "form-404-module--alice-carousel__dots-item--07343";
export var btnGroup = "form-404-module--btn-group--af7bb";
export var ccCompliance = "form-404-module--cc-compliance--f951d";
export var h1 = "form-404-module--h1--496a7";
export var h2 = "form-404-module--h2--8f5da";
export var h3 = "form-404-module--h3--73d50";
export var h4 = "form-404-module--h4--c8f74";
export var link = "form-404-module--link--b03a4";
export var maxWidth = "form-404-module--max-width--7284b";
export var menuOpen = "form-404-module--menu-open--00ac4";
export var noChildPMb = "form-404-module--no-child-p-mb--b1cc6";
export var nobar = "form-404-module--nobar--585a1";
export var pin = "form-404-module--pin--44df6";
export var seogroup = "form-404-module--seogroup--abcff";
export var wrapper = "form-404-module--wrapper--9b82b";